import { useState } from "react";
import HelpForm from "../../Home/Components/FindOutHelpForm/helpForm/HelpFormpdf";
import "./downloadFactSheet.css";

const SuccessMessage = () => {
  return (
    <div className="SuccessMessage-cnt">
      <p className="SuccessMessage-head">
        Thanks for downloading our Fact Sheet!
      </p>
      <p className="SuccessMessage-subhead">
        Please check your email for the download link. 
      </p>
    </div>
  );
};

const FactSheetDownload = () => {
  const [isFormSuccessFull, setIsFormSuccessfull] = useState(false);
  const onSubmitForm = () => {
    setIsFormSuccessfull(true);
  };
  return (
    <section className="FactSheetDownLoadContainer-page">
      <div className="FactSheetDownLoadContainer">
        <p className="FactSheetDownLoadContainer-text">
          Download Our Fact Sheet: Quick Access to Key Insights and Essential
          Information
        </p>
        <HelpForm onSubmitForm={onSubmitForm} />
      </div>
      {isFormSuccessFull && <SuccessMessage />}
    </section>
  );
};

export default FactSheetDownload;
